import { IAdGroupPositionOptional } from '@unfoldrtech/portal-mic'

export function transformPositionTarget(postTarget: IAdGroupPositionOptional) {
  return {
    ...postTarget,
    bidPrice: Number(postTarget.bidPrice),
  }
}
